// Define action types
export const SET_PROOFFER = 'SET_PROOFFER';
